// DonationTable.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDonationDispatch } from "../context/DonationContext";
import { DONATION_OPTIONS } from "../data/donationOptions";

export default function DonationTable() {
  const dispatch = useDonationDispatch();
  const navigate = useNavigate();

  function handleDonateClick(opt) {
    dispatch({
      type: "SET_SELECTION",
      payload: { id: opt.id, amount: opt.amount },
    });
    // Add query fallback
    const q = new URLSearchParams({ opt: opt.id, amt: opt.amount ?? "" });
    navigate(`/QuickDonate?${q.toString()}`);
  }

  return (
    <div style={{ maxWidth: 980, margin: "0 auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ textAlign: "left", borderBottom: "2px solid #eee" }}>
            <th style={{ padding: "12px" }}>Seva</th>
            <th style={{ padding: "12px", width: 160 }}>Amount</th>
            <th style={{ padding: "12px", width: 140 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {DONATION_OPTIONS.map((opt) => (
            <tr key={opt.id} style={{ borderBottom: "1px solid #f0f0f0" }}>
              <td style={{ padding: "14px 12px" }}>{opt.label}</td>
              <td style={{ padding: "14px 12px" }}>
                {opt.amount ? `₹${opt.amount.toLocaleString()}` : "—"}
              </td>
              <td style={{ padding: "14px 12px" }}>
                <button
                  onClick={() => handleDonateClick(opt)}
                  style={{
                    background: "#c61d21",
                    color: "white",
                    padding: "10px 14px",
                    borderRadius: 6,
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  Donate
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
